var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_vm._m(0),_c('div',{staticClass:"content"},[_c('div',{staticClass:"header"}),_c('div',{staticClass:"slot"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2),_c('div',{staticClass:"bottom"})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image media-hidden-md"},[_c('div',{staticClass:"background"})])
}]

export { render, staticRenderFns }